import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import api from "../../services/api";
import { store } from "react-notifications-component";
import GenericUpper from "../../components/generic-upper";
import PrescriptionStepOne from "../../components/prescriptionsteps/step1";
import PrescriptionStepTwo from "../../components/prescriptionsteps/step2";
import PrescriptionStepThree from "../../components/prescriptionsteps/step3";
import Button from '../../components/button/button_v2';
import ModalYesNo from "../../components/modal/modalYesNo";
import ModalPassword from "../../components/modal/modal_password";
import ModalUpload from '../../components/modal/modalUploadCertificado';
import ModalAlert from '../../components/modal/modalGeneric';
import { formatDate } from "../../services/formatDate";
import { getIp } from "../../services/getIp";
import PrescriptionStepFour from "../../components/prescriptionsteps/step4";
import { DivSaldo, DivSaldoContainer } from '../receitas/styles';
import PrescriptionStepFive from "../../components/prescriptionsteps/step5";

import { ContainerModal, ButtonPlans } from './styles';
import { TaglineP, Auxiliar, BodyG, BodyGSpan, BodyM, H5 } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';
import ModalGeneric from '../../components/modal/modalGeneric';
import InputV3 from "../../components/input/novo/input_v3";
import ButtonV2 from '../../components/button/button_v2';

import UndrawAlert from "../../assets/icons/undraw-alert.svg";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';
import maintainUtm from "../../services/maintainUtm";
import { getCurrentPageIdWithDevice } from "../../services/maintainUtm/idPages";

import { isTotvs, isOmie, isNfAposReceita, orgaoHomologacaoNfAposReceita } from "../../services/globalFunctions";
import ModalAlertTotvs from "../../components/modal/modalAlertTotvs";
import { getReceitaSolicitada } from "../../services/receitaSolicitada";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const AddReceitasLote = ({ ...props }) => {

    const [title] = useState("Descobrindo o problema");
    const [subtitle, setSubtitle] = useState("");
    const [maxRelations, setMaxRelations] = useState("");
    const [align] = useState("center");
    const [userIp, setUserIp] = useState('');
    const [loadParams, setLoadParams] = useState(false);


    //step1
    const [stepOneParams, setStepOneParams] = useState([]);
    const [dataEmissao, setDataEmissao] = useState('');
    const [countRelations, setCountRelations] = useState(0);
    const [erroStepOne, setErroStepOne] = useState(false);


    //step2
    const [stepTwoParams, setStepTwoParams] = useState([]);
    const [existParamsStepTwo, setExistParamsStepTwo] = useState(false);
    const [stepTwoError, setStepTwoError] = useState(false);
    const [isOpenStepTwo, setIsOpenStepTwo] = useState(false);
    const [errosNfGo, setErrosNfGo] = useState([]);

    //step3
    const [stepThreeParams, setStepThreeParams] = useState([]);
    const [existParamsStepThree, setExistParamsStepThree] = useState(false);
    const [disabledStepThree, setDisabledStepThree] = useState(true);
    const [stepThreeError, setStepThreeError] = useState(false);
    const [isOpenStepThree, setIsOpenStepThree] = useState(false);

    const [senha, setSenha] = useState('');

    const [showModalYesNo, setShowModalYesNo] = useState(false);
    const [showModalPassword, setShowModalPassword] = useState(false);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [openUpload, setOpenUpload] = useState(false);

    const [disabledFinish, setDisabledFinish] = useState(true);

    //step5
    const [relationsSelecionadas, setRelationsSelecionadas] = useState([]);
    const [siccaInfo, setSiccaInfo] = useState('');

    //compendio
    const [existCompendioParams, setExistCompendioParams] = useState(false);
    const [compendioParams, setCompendioParams] = useState([]);

    // Rascunho de solicitação (TOTVS/Omie) - preenche produto(s)/produtor/fazenda
    // travados quando a emissão vem da tela de Solicitações de Receitas.
    const [dataItemRecipe, setDataItemRecipe] = useState({});
    const [dataUser, setDataUser] = useState({});

    // NÃO limpa o sessionStorage aqui (nem no cleanup do efeito, nem na leitura) - vários
    // componentes filhos (ex.: step1/relation.js, "Quantidade vendida") chamam
    // hasReceitaSolicitada() direto no sessionStorage durante toda a vida da página, não só
    // uma vez no mount. Limpar cedo (já tentamos via cleanup e via leitura) fazia esses
    // checks passarem a dar falso depois, escondendo campos que dependem disso. O TTL de 2h
    // do próprio helper + o fato de cada clique numa solicitação já sobrescrever antes de
    // navegar já evitam dado velho vazar pra uma sessão futura.
    const recipeReadRef = useRef(false);
    useEffect(() => {
        if (recipeReadRef.current) return;
        recipeReadRef.current = true;
        if ((isTotvs() || isOmie()) && dataUser.agro_permission_id !== 4) {
            const item = getReceitaSolicitada() || {};
            const user = JSON.parse(localStorage.getItem('@userinfo')) || {};
            setDataItemRecipe(item);
            setDataUser(user);
        }
    }, []);
    const [loadingPrescription, setLoadingPrescription] = useState(false);
    const [existPassword, setExistPassword] = useState(false);
    const [sendPrescription, setSendPrescription] = useState(false);
    const [msgError, setMsgError] = useState('');

    const [iniciaVerificacao, setIniciaVerificacao] = useState(false);
    const [existEmptyValues, setExistEmptyValues] = useState(true);
    const [isApto, setIsApto] = useState(true);
    const [planoConfig, setPlanoConfig] = useState([]);
    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [saldoReceitas, setSaldoReceitas] = useState('')
    const [showUpgradeCreditsModal, setShowUpgradeCreditsModal] = useState(false)
    const [produtosSelecionados, setProdutosSelecionados] = useState([]);
    const [NFeInfo, setNFeInfo] = useState('');

    const [exitDateValidation, setExitDateValidation] = useState(false);
    const [showExitValidation, setShowExitValidation] = useState(false);

    // Modal Totvs
    const [showModalTotvs, setShowModalTotvs] = useState(false);

    // Inputs modal
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [inicialDate, setInicialDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState('');
    const [priceContract, setPriceContract] = useState('');

    const [inicialDateError, setInicialDateError] = useState(false);
    const [endDateError, setEndDateError] = useState(false);
    const [priceContractError, setPriceContractError] = useState(false);

    const [loadingCreateContract, setLoadingCreateContract] = useState(false);

    const notifyContratoDateError = (message) => {
        store.addNotification({
            title: "Erro!",
            message,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 6000,
                onScreen: true
            }
        });
    };

    const toISODate = (value) => {
        if (!value) return null;
        const str = String(value);
        if (str.includes('T')) return str.slice(0, 10);
        if (str.includes('/')) {
            const [d, m, y] = str.split('/');
            if (!y || !m || !d) return null;
            return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        if (str.includes('-')) {
            return str.slice(0, 10);
        }
        return null;
    };

    useEffect(() => {
        if (dataEmissao) {
            setInicialDate(dataEmissao);
            setInicialDateError(false);
        }
    }, [dataEmissao]);

    useEffect(() => {
        if (localStorage.getItem("reloadEmissaoLote") === "true") {
            localStorage.setItem("reloadEmissaoLote", "false")
            window.location.reload()
        }
    }, [])

    const validaSaldo = async () => {
        try {
            const response = await api.get(`planos/qtd-receitas`);
            const saldoData = response.data.data.saldo_receitas;

            if (response) {
                setIsApto(true);
                setSaldoReceitas(saldoData)
            }

        } catch (error) {
            if (error.response.status === 423) {
                setIsApto(false);
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 10000,
                        onScreen: true
                    }
                });
            }
        }
    }

    const goHome = () => {
        setIsApto(!isApto);
        props.history.push('/');
    }

    const goToPlans = () => {
        setIsApto(!isApto);
        props.history.push('/planos');
    }

    const getIsBasicOrPrePagoPlan = () => {
        const planName = String(planoConfig?.nome_plano || '').normalize("NFD").replace(/[̀-ͯ]/g, '').toUpperCase().trim();
        const isBasicPlan = planName === "PLANO BASIC";
        const isPrePagoPlan = planName === "PLANO PRE-PAGO" || planoConfig?.is_pre_pago === true || planoConfig?.agro_plan_id === 6;
        return isBasicPlan || isPrePagoPlan;
    }

    const goToPlansWithCoupon = () => {
        setShowUpgradeCreditsModal(false);
        const searchParams = new URLSearchParams(props.location?.search || '');
        searchParams.set('cupom', 'UP20');
        props.history.push(`/planos?${searchParams.toString()}`);
    }

    const goToReceitas = () => {
        setIsApto(!isApto);
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modalreceitascabou`);
        props.history.push(`/comprar_receitas${search}`);
    }

    const goToLimit = () => {
        setIsApto(!isApto);
        const currentPageId = getCurrentPageIdWithDevice();
        const search = maintainUtm(`${currentPageId}-modallimitemensalacabou`);
        props.history.push(`/comprar_limite${search}`);
    }

    const saveIp = async () => {
        await getIp(function (ipUser) {
            setUserIp(ipUser);
        });
    }

    const updateParamsOne = (value) => {

        setStepOneParams(value);
        if (value.relations.length > 0) {
            if (value.relations[0]) {
                if (value.relations[0].date) {
                    setDataEmissao(value.relations[0].date);
                }
            }
        }

        if (value.estado) {
            if (value.estado.value === '' && value.estado.label === '') {
                setMsgError('Selecione um estado!');
                setStepTwoParams([]);
                setStepThreeParams([]);
                setExistParamsStepTwo(false);
                setExistParamsStepThree(false);
                // setDisabledStepThree(true);
            } else {
                if (value.estado.value === '') {
                    setMsgError('Selecione um estado!');
                    // setDisabledStepThree(true);

                } else {
                    if (value.estado.value !== 'RJ') {
                        if (stepTwoParams != []) {
                            if (stepTwoParams.art && stepTwoParams.art != undefined) {
                                // setDisabledStepThree(false);
                            } else {
                                // setDisabledStepThree(true);
                            }
                        } else {
                            // setDisabledStepThree(true);
                        }
                    } else {
                        if (stepTwoParams.length !== 0) {
                            // setDisabledStepThree(false);
                        }

                    }
                }
            }
        } else {
            // setDisabledStepThree(true);
        }
        setRelationsSelecionadas(value.relations);
        setProdutosSelecionados(value.produtos);
    }

    const resetStepThree = () => {
        setStepThreeParams([]);
        setExistParamsStepThree(false);
        setStepThreeError(false);
        setIsOpenStepThree(false);
    }

    const updateParamsTwo = (value) => {

        setStepTwoParams(value);

        if (stepTwoParams.length > 0) {
            if (stepTwoParams.art !== '' && stepTwoParams.crea !== '' && value.art !== '' && value.crea !== '') {
                if (stepTwoParams.art.value !== value.art.value || stepTwoParams.crea.value !== value.crea.value) {
                    resetStepThree()
                }
            }
        }

        if (value.password) {
            setSenha(value.password);
        }


        if (value.responsavel.value || value.crea.value || value.assinatura.value || value.art.value) {
            if (value.erroUser) {
                // setDisabledStepThree(true);
                setExistParamsStepTwo(true);
            } else {
                setMsgError('');
                if (stepOneParams.estado.value === 'RJ') {
                    if (value.responsavel.value && value.crea.value && value.assinatura.value) {
                        // setDisabledStepThree(false);
                    }
                } else if (value.responsavel.value && value.crea.value && value.assinatura.value && value.art.value) {
                    // setDisabledStepThree(false);
                }

                setExistParamsStepTwo(true);
            }
        } else {
            if (stepOneParams.estado) {
                if (stepOneParams.estado.value === 'SP' || stepOneParams.estado.value === 'MG') {
                    if (value.art) {
                        // setDisabledStepThree(false);
                        setExistParamsStepTwo(false);
                    } else {
                        // setDisabledStepThree(true);
                        setExistParamsStepTwo(false);
                    }
                } else {
                    // setDisabledStepThree(true);
                    setExistParamsStepTwo(false);
                }
            }
        }

        if (value.erroResponsavel === true || value.erroCrea === true || value.erroAssinatura === true || value.erroArt === true) {
            setStepTwoError(true);
        } else {
            setMsgError('');
            setStepTwoError(false);
        }
    }

    const updateIsOpenStepTwo = (isOpen) => {

        if (isOpen === true) {
            if (isOpenStepThree === true) {
                setIsOpenStepThree(false);
            }
        }
        setIsOpenStepTwo(isOpen);
    }

    const updateParamsThree = (value) => {

        if (value.produtor || value.fazenda || value.devolucao) {
            setMsgError('');
            setExistParamsStepThree(true);
            setStepThreeParams(value);
            setDisabledStepThree(false);
        }

        if (value.erroProdutor === true || value.erroFazenda === true || value.erroDevolucao === true) {
            setStepThreeError(true);
            setDisabledStepThree(true);
        } else {
            setMsgError('');
            setStepThreeError(false);
            setDisabledStepThree(false);
        }


    }

    const updateIsOpenStepThree = (isOpen) => {
        if (isOpen === true) {
            if (isOpenStepTwo === true) {
                setIsOpenStepTwo(false);
            }
        }
        setIsOpenStepThree(isOpen);
    }

    const updateQuantidadeRelations = (quantidade) => {
        setMaxRelations(quantidade);
    }

    const validatePrescription = (params) => {
        if (params) {

            if (params.stepOneParams) {

                if (params.stepOneParams.estado && params.stepOneParams.estado !== '') {
                    if (params.stepOneParams.estado.value) {
                        if (params.stepOneParams.cultura != '') {
                            if (params.stepOneParams.relations != []) {
                                if (params.stepOneParams.relations.length > 0) {

                                    if (params.stepOneParams.relations[0]) {
                                        if (erroStepOne === false) {
                                            if (
                                                params.stepOneParams.relations[0].areaTratar !== '' &&
                                                params.stepOneParams.relations[0].dose !== '' &&
                                                params.stepOneParams.relations[0].modalidadeAplicacao &&
                                                params.stepOneParams.relations[0].numeroAplicacoes !== '' &&
                                                params.stepOneParams.relations[0].quantidadeAdquirir !== '' &&
                                                params.stepOneParams.relations[0].unidadeQuantidadeAdquirir !== '' &&
                                                params.stepOneParams.relations[0].volumeCalda !== ''
                                            ) {
                                                if (params.dataEmissao) {
                                                    setMsgError('');
                                                    if (params.existParamsStepTwo === true && params.existParamsStepThree === true) {
                                                        if (params.stepTwoError === false && params.stepThreeError === false) {
                                                            if (params.stepTwoParams) {
                                                                if (params.stepTwoParams.erroResponsavel === false && params.stepTwoParams.erroCrea === false && params.stepTwoParams.erroArt === false) {
                                                                    if (params.stepTwoParams.responsavel.value) {
                                                                        if (params.stepTwoParams.crea.value) {
                                                                            if (params.stepTwoParams.assinatura.value) {
                                                                                if (params.stepOneParams.estado.value != 'RJ') {
                                                                                    if (params.stepTwoParams.art.value) {
                                                                                        //valida step3
                                                                                        if (params.stepThreeParams) {
                                                                                            if (params.stepThreeParams.erroProdutor === false && params.stepThreeParams.erroFazenda === false && params.stepThreeParams.erroDevolucao === false) {
                                                                                                if (params.stepThreeParams.produtor.value) {
                                                                                                    if (params.stepThreeParams.fazenda.value) {
                                                                                                        if (params.stepOneParams.estado.value === 'SP') {
                                                                                                            setDisabledFinish(false);
                                                                                                        } else if (params.stepThreeParams.devolucao.value) {
                                                                                                            if (existEmptyValues) {
                                                                                                                setDisabledFinish(true);
                                                                                                                setMsgError('Existem relações incompletas!');
                                                                                                            } else {
                                                                                                                setDisabledFinish(false);
                                                                                                            }
                                                                                                        } else {
                                                                                                            setDisabledFinish(true);
                                                                                                        }
                                                                                                    } else {
                                                                                                        setDisabledFinish(true);
                                                                                                    }
                                                                                                } else {
                                                                                                    setDisabledFinish(true);
                                                                                                }
                                                                                            } else {
                                                                                                setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                                                                setDisabledFinish(true);
                                                                                            }
                                                                                        } else {
                                                                                            setDisabledFinish(true);
                                                                                        }
                                                                                    } else {
                                                                                        setDisabledFinish(true);
                                                                                    }
                                                                                } else {
                                                                                    // Exigir ART no RJ quando CREA.tipo === 'cfta'
                                                                                    const isCFTA = params?.stepTwoParams?.crea?.tipo === 'cfta';
                                                                                    if (isCFTA && !params?.stepTwoParams?.art?.value) {
                                                                                        setDisabledFinish(true);
                                                                                    } else {
                                                                                        //valida step3
                                                                                        if (params.stepThreeParams) {
                                                                                            if (params.stepThreeParams.erroProdutor === false && params.stepThreeParams.erroFazenda === false && params.stepThreeParams.erroDevolucao === false) {
                                                                                                if (params.stepThreeParams.produtor.value) {
                                                                                                    if (params.stepThreeParams.fazenda.value) {
                                                                                                        if (params.stepThreeParams.devolucao.value) {
                                                                                                            if (existEmptyValues) {
                                                                                                                setDisabledFinish(true);
                                                                                                                setMsgError('Existem relações incompletas!');
                                                                                                            } else {
                                                                                                                setDisabledFinish(false);
                                                                                                            }
                                                                                                        } else {
                                                                                                            setDisabledFinish(true);
                                                                                                        }
                                                                                                    } else {
                                                                                                        setDisabledFinish(true);
                                                                                                    }
                                                                                                } else {
                                                                                                    setDisabledFinish(true);
                                                                                                }
                                                                                            } else {
                                                                                                setDisabledFinish(true);
                                                                                            }
                                                                                        } else {
                                                                                            setDisabledFinish(true);
                                                                                        }
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                setDisabledFinish(true);
                                                                            }
                                                                        } else {
                                                                            setDisabledFinish(true);
                                                                        }
                                                                    } else {
                                                                        setDisabledFinish(true);
                                                                    }
                                                                } else {
                                                                    setMsgError('Verifique as informações do responsável técnico');

                                                                    setDisabledFinish(true);
                                                                }
                                                            } else {
                                                                setDisabledFinish(true);
                                                            }
                                                        } else {
                                                            if (params.stepTwoError) {
                                                                setMsgError('Verifique as informações do responsável técnico');

                                                            }

                                                            if (params.stepThreeError) {
                                                                setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                            }
                                                            setDisabledFinish(true);
                                                        }
                                                    } else {
                                                        if (params.stepTwoError) {
                                                            setMsgError('Verifique as informações do responsável técnico');

                                                        }

                                                        if (params.stepThreeError) {
                                                            setMsgError('Verifique as informações de onde o produto será aplicado!');

                                                        }
                                                        setDisabledFinish(true);
                                                    }
                                                } else {
                                                    setDisabledFinish(true);
                                                }
                                            } else {
                                                setMsgError('Verifique a prescrição do(s) produto(s)!');
                                                setDisabledFinish(true);
                                            }
                                        } else {
                                            setMsgError('Existem erros nas relações!');
                                            setDisabledFinish(true);
                                        }
                                    }
                                } else {
                                    setDisabledFinish(true);
                                }
                            } else {
                                setDisabledFinish(true);
                            }
                        } else {
                            if (params.stepOneParams.length > 0) {
                                if (params.stepOneParams.relations.length > 0) {
                                    setMsgError('Selecione uma cultura!');
                                }
                            } else if (params.stepOneParams.length === undefined) {
                                setMsgError('Selecione uma cultura!');
                            }
                            setDisabledFinish(true);
                        }
                    } else {
                        if (params.stepOneParams.length > 0) {
                            if (params.stepOneParams.relations.length > 0) {
                                setMsgError('Selecione um estado!');
                            }
                        } else if (params.stepOneParams.length === undefined) {
                            setMsgError('Selecione um estado!');
                        }
                        setDisabledFinish(true);
                    }
                } else {

                    if (params.stepOneParams.length > 0) {
                        if (params.stepOneParams.relations.length > 0) {
                            setMsgError('Selecione um estado!');
                        }
                    } else if (params.stepOneParams.length === undefined) {
                        setMsgError('Selecione um estado!');
                    }
                    setDisabledFinish(true);
                }
            } else {
                setDisabledFinish(true);
            }
        } else {
            setDisabledFinish(true);
        }
    }

    //formats
    const formatRelationsIds = (relations) => {
        let format = [];

        relations.map((rel) => {
            format = [...format, rel.relationId];
        });

        return format;
    }

    const formatAplicationModesIds = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.modalidadeAplicacao.value) {
                format = [...format, rel.modalidadeAplicacao.value];
            }
        });

        return format;
    }

    const formatDoses = (relations) => {
        let format = [];

        relations.map((rel) => {
            const raw = rel?.dose;
            if (raw === undefined || raw === null || raw === '') {
                format = [...format, raw];
                return;
            }
            // Normaliza decimal pt-BR ("1,5") → 1.5
            const normalized = typeof raw === 'string' ? raw.replace(',', '.') : raw;
            const parsed = Number(normalized);
            format = [...format, Number.isFinite(parsed) ? parsed : raw];
        });

        return format;
    }

    const formatNumeroAplicacoes = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.numeroAplicacoes) {
                format = [...format, rel.numeroAplicacoes];
            }
        });

        return format;
    }

    const formatQuantidadeAdquirir = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.quantidadeAdquirir) {
                format = [...format, rel.quantidadeAdquirir];
            }
        });

        return format;
    }

    const formatUnidade = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.unidadeQuantidadeAdquirir) {
                format = [...format, rel.unidadeQuantidadeAdquirir];
            }
        });

        return format;
    }

    const formatArea = (relations) => {
        let format = [];

        relations.map((rel) => {
            if (rel.areaTratar) {
                format = [...format, rel.areaTratar];
            }
        });

        return format;
    }

    const formatEquipamento = (relations) => {
        let format = [];

        relations.map((rel) => {
            const eq = rel && 'equipamento' in rel ? rel.equipamento : undefined;
            if (eq === null || eq === undefined) {
                format = [...format, ""];
            } else {
                format = [...format, typeof eq === "string" ? eq : String(eq)];
            }
        });

        return format;
    }

    const formatVolume = (relations) => {
        let format = [];

        relations.map((rel) => {
            format = [...format, rel.volumeCalda];
        });

        return format;
    }

    const validaRelations = () => {
        setIniciaVerificacao(true);
    }

    const updateYesNo = async (resposta) => {
        if (resposta === 1) {
            setShowModalYesNo(false);
            validaRelations();
        } else {
            setShowModalYesNo(false);
        }
    }

    const updatePassword = (senha) => {
        setSenha(senha);
        setShowModalPassword(false);
        setExistPassword(true);
    }

    const enviarReceita = () => {
        if (getIsBasicOrPrePagoPlan() && Number(saldoReceitas) === 0) {
            setShowUpgradeCreditsModal(true);
            return;
        }
        setSendPrescription(true);
    }

    const updateYesNoDateValidate = (e) => {
        if (e === 1) {
            setExitDateValidation(true);
            setShowExitValidation(false);

            setTimeout(() => {
                enviarReceita();
            }, 300);
        } else {
            setShowExitValidation(false);
            setLoadingPrescription(false);

            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 200);
        }
    }

    const validaNFe = (nf) => {
        const erros = [];

        if (!nf.chaveAcesso) {
            erros.push('chaveAcesso')
        }

        if (!nf.razaoSocial) {
            erros.push('razaoSocial')
        }

        if (!nf.cpfCnpj) {
            erros.push('cpfCnpj')
        }

        if (!nf.endereco) {
            erros.push('endereco')
        }

        if (!nf.bairro) {
            erros.push('bairro')
        }

        if (!nf.municipio) {
            erros.push('municipio')
        }

        if (!nf?.estado?.value) {
            erros.push('estado')
        }

        if (!nf.dataEmissao) {
            erros.push('dataEmissao')
        }

        if (nf.produtos[0] == '') {
            erros.push('produtos')
        }

        if (!nf.ncmProdutos.length > 0) {
            erros.push('ncmProdutos')
        }


        if (!nf.unidades.length > 0) {
            erros.push('unidades')
        }

        if (!nf.quantidades.length > 0) {
            erros.push('quantidades')
        }

        setErrosNfGo(erros);

        if (
            nf.chaveAcesso &&
            nf.razaoSocial &&
            nf.cpfCnpj &&
            nf.endereco &&
            nf.bairro &&
            nf.municipio &&
            nf?.estado?.value &&
            nf.dataEmissao &&
            nf.codigosProduto &&
            nf.produtos &&
            nf.ncmProdutos &&
            nf.unidades &&
            nf.quantidades
        ) {
            return true;
        } else {
            return false;
        }
    }

    const emitirReceita = async (values) => {
        try {
            if (values.stepTwoParams.assinatura.value === 'D' && senha === '') {
                setShowModalPassword(true);
            } else {
                setLoadingPrescription(true);
                const agro_relation_id = formatRelationsIds(values.stepOneParams.relations);
                const agro_aplication_mode_id = formatAplicationModesIds(values.stepOneParams.relations);
                const dose = formatDoses(values.stepOneParams.relations);
                const numero_aplicacoes = formatNumeroAplicacoes(values.stepOneParams.relations);
                const quantidade_adquirir = formatQuantidadeAdquirir(values.stepOneParams.relations);
                const unidade_quantidade_adquirir = formatUnidade(values.stepOneParams.relations);
                const area_tratar = formatArea(values.stepOneParams.relations);
                const equipamento_aplicacao = formatEquipamento(values.stepOneParams.relations);
                const volume_calda = formatVolume(values.stepOneParams.relations);


                const contRelations = agro_relation_id.length;

                if (
                    area_tratar.length === contRelations &&
                    dose.length === contRelations &&
                    equipamento_aplicacao.length === contRelations &&
                    numero_aplicacoes.length === contRelations &&
                    quantidade_adquirir.length === contRelations &&
                    unidade_quantidade_adquirir.length === contRelations &&
                    contRelations == countRelations
                ) {

                    let payload = {};

                    let emitir = false;

                    const safeNumNf = NFeInfo?.numNf !== undefined && NFeInfo?.numNf !== null ? String(NFeInfo.numNf) : '';

                    if (isNfAposReceita(stepOneParams.estado.value)) {
                        // const nfIncompleta =
                        //     !NFeInfo ||
                        //     !NFeInfo.chaveAcesso ||
                        //     !Array.isArray(NFeInfo.produtos) || NFeInfo.produtos.length === 0 ||
                        //     !Array.isArray(NFeInfo.ncmProdutos) || NFeInfo.ncmProdutos.length === 0 ||
                        //     !Array.isArray(NFeInfo.unidades) || NFeInfo.unidades.length === 0 ||
                        //     !Array.isArray(NFeInfo.quantidades) || NFeInfo.quantidades.length === 0;

                        // validaNFe(NFeInfo);

                        // if (nfIncompleta && !exitDateValidation) {
                        //     setShowExitValidation(true);
                        //     setSendPrescription(false);
                        //     return;
                        // }

                        emitir = true
                        payload = {
                            order_id: dataItemRecipe.id,
                            agro_relation_id,
                            agro_aplication_mode_id,
                            dose,
                            volume_calda,
                            numero_aplicacoes,
                            quantidade_adquirir,
                            unidade_quantidade_adquirir,
                            area_tratar,
                            equipamento_aplicacao,
                            agro_crea_id: values.stepTwoParams.crea.value,
                            agro_art_id: values.stepTwoParams.art.value,
                            agro_farm_id: values.stepThreeParams.fazenda.value,
                            agro_devolution_id: values.stepThreeParams.devolucao.value,
                            assinatura: values.stepTwoParams.assinatura.value,
                            salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                            senha,
                            data_emissao: dataEmissao,
                            ip: userIp,
                            lat: lat ? lat : null,
                            lng: lng ? lng : null,
                            chave_acesso: '',
                            razao_social_emissor: '',
                            cpf_cnpj_emissor: '',
                            endereco_emissor: '',
                            bairro_emissor: '',
                            municipio_emissor: '',
                            uf_emissor: '',
                            data_emissao_nf: '',
                            nome_produto: [],
                            ncm_produto: [],
                            unidade_medida: [],
                            qtd_produto: [],
                            num_nf: '',
                            exit_date_validation: exitDateValidation,
                        }

                        // } else {
                        //     store.addNotification({
                        //         title: "Erro!",
                        //         message: `Todos os campos da nota fiscal são obrigatórios!`,
                        //         type: "danger",
                        //         insert: "top",
                        //         container: "top-right",
                        //         animationIn: ["animated", "fadeIn"],
                        //         animationOut: ["animated", "fadeOut"],
                        //         dismiss: { duration: 6000, onScreen: true }
                        //     });
                        // }

                    } else if (stepOneParams.estado.value === 'SP') {
                        const toISODate = (value) => {
                            if (!value) return null;
                            const str = String(value);
                            if (str.includes('T')) return str.slice(0, 10);
                            if (str.includes('/')) {
                                const [d, m, y] = str.split('/');
                                if (!y || !m || !d) return null;
                                return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
                            }
                            if (str.includes('-')) {
                                return str.slice(0, 10);
                            }
                            return null;
                        };

                        const emissaoISO = toISODate(dataEmissao);
                        const contratosArt = Array.isArray(values.stepTwoParams?.art?.contratos) ? values.stepTwoParams.art.contratos : [];
                        const farmId = values.stepThreeParams?.fazenda?.value;

                        if (emissaoISO && contratosArt.length > 0 && farmId) {
                            const contratosFarm = contratosArt.filter(c => String(c.agro_farm_id) === String(farmId));
                            const contratosAtivos = contratosFarm.filter(c => c.status === 1);
                            const pool = contratosAtivos.length > 0 ? contratosAtivos : contratosFarm;

                            const ok = pool.some(c => {
                                const ini = toISODate(c.data_inicio);
                                const fim = toISODate(c.data_termino);
                                if (!ini || !fim) return false;
                                return emissaoISO >= ini && emissaoISO <= fim;
                            });

                            if (!ok && pool.length > 0) {
                                const isoToBR = (iso) => {
                                    if (!iso) return '';
                                    const [y, m, d] = String(iso).split('-');
                                    if (!y || !m || !d) return '';
                                    return `${d}/${m}/${y}`;
                                };

                                const range = pool.reduce(
                                    (acc, c) => {
                                        const ini = toISODate(c.data_inicio);
                                        const fim = toISODate(c.data_termino);
                                        if (ini && (!acc.minIni || ini < acc.minIni)) acc.minIni = ini;
                                        if (fim && (!acc.maxFim || fim > acc.maxFim)) acc.maxFim = fim;
                                        return acc;
                                    },
                                    { minIni: null, maxFim: null }
                                );

                                const inicioBr = isoToBR(range.minIni);
                                const terminoBr = isoToBR(range.maxFim);
                                const periodoTxt = inicioBr && terminoBr ? ` (${inicioBr} a ${terminoBr})` : '';

                                store.addNotification({
                                    title: "Erro!",
                                    message: `A data de emissão da receita está fora do período do contrato dessa ART${periodoTxt}`,
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 6000,
                                        onScreen: true
                                    }
                                });
                                setLoadingPrescription(false);
                                return;
                            }
                        }

                        const contratoExiste = await validaContratoSP(
                            values.stepTwoParams.art.value,
                            values.stepThreeParams.produtor.value,
                            values.stepThreeParams.fazenda.value
                        );

                        setArtForSearch(values.stepTwoParams.art.value);

                        if (!contratoExiste) {
                            setLoadingPrescription(false);
                            return;
                        }

                        emitir = true;
                        payload = {
                            order_id: dataItemRecipe.id,
                            agro_relation_id,
                            agro_aplication_mode_id,
                            dose: dose.map((item) => Number(item)),
                            volume_calda,
                            numero_aplicacoes,
                            quantidade_adquirir,
                            unidade_quantidade_adquirir,
                            area_tratar,
                            equipamento_aplicacao,
                            agro_crea_id: values.stepTwoParams.crea.value,
                            agro_art_id: values.stepTwoParams.art.value,
                            agro_farm_id: values.stepThreeParams.fazenda.value,
                            agro_devolution_id: values.stepThreeParams.devolucao.value || "",
                            assinatura: values.stepTwoParams.assinatura.value,
                            salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                            senha,
                            data_emissao: dataEmissao,
                            // hora_emissao: hour,
                            ip: userIp,
                            lat: lat ? lat : null,
                            lng: lng ? lng : null,
                            num_nf: safeNumNf,
                            exit_date_validation: exitDateValidation,
                            sicca: siccaInfo ? siccaInfo : [],
                            // complementar_mt: firstMtInfo.firstPrescription,
                            // numero_primeira_art: firstMtInfo.numberFirstArt
                        }
                    } else {
                        emitir = true;
                        payload = {
                            order_id: dataItemRecipe.id,
                            agro_relation_id,
                            agro_aplication_mode_id,
                            dose: dose.map(item => Number(item)),
                            volume_calda,
                            numero_aplicacoes,
                            quantidade_adquirir,
                            unidade_quantidade_adquirir,
                            area_tratar,
                            equipamento_aplicacao,
                            agro_crea_id: values.stepTwoParams.crea.value,
                            agro_art_id: values.stepTwoParams.art.value ? values.stepTwoParams.art.value : null,
                            agro_farm_id: values.stepThreeParams.fazenda.value,
                            agro_devolution_id: values.stepThreeParams.devolucao.value,
                            assinatura: values.stepTwoParams.assinatura.value,
                            salvarAssinatura: values.stepTwoParams.salvarAssinatura,
                            senha,
                            data_emissao: dataEmissao,
                            ip: userIp,
                            lat: lat ? lat : null,
                            lng: lng ? lng : null,
                            num_nf: safeNumNf,
                            exit_date_validation: exitDateValidation,
                            sicca: siccaInfo ? siccaInfo : []
                        }
                    }

                    if (emitir) {
                        const response = await api.post(`/receitas/lote`, payload);
                        // const receitaId = response.data.data.id;

                        if (response) {

                            if (response.status === 206) {
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: `Receita emitida com sucesso!`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 4000,
                                        onScreen: true
                                    }
                                });
                                if (response.data.message === "A receita precisa ser assinada pelo responsável técnico antes de ser enviada!") {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `${response.data.message}`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 10000,
                                            onScreen: true
                                        }
                                    });
                                } else {
                                    store.addNotification({
                                        title: "Erro!",
                                        message: `${response.data.message}  Aguarde alguns minutos ou entre em contato com nosso suporte!`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 10000,
                                            onScreen: true
                                        }
                                    });
                                }
                            } if (response.status === 426) {
                                setShowExitValidation(true);
                                setSendPrescription(false);
                            } else {
                                if (response.status === 200 && response.data.message) {
                                    store.addNotification({
                                        title: "Sucesso!",
                                        message: `${response.data.message}`,
                                        type: "success",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                } else {
                                    store.addNotification({
                                        title: "Sucesso!",
                                        message: "Receita emitida com sucesso!",
                                        type: "success",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                }
                            }

                            props.history.push('/historico');

                            const pdfList = Array.isArray(response?.data?.data) ? response.data.data : [];
                            pdfList.forEach((pdf) => {
                                window.open(pdf);
                            });

                            // window.open(response.data.data.receita_pdf);
                        }
                    }
                } else {
                    store.addNotification({
                        title: "Erro!",
                        message: `Existem prescrições incompletas! \nRevise os produtos e emita novamente!`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 6000,
                            onScreen: true
                        }
                    });
                    setTimeout(() => {
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }, 200);
                }



                setLoadingPrescription(false);
            }
        } catch (e) {
            const errorData = e?.response?.data || {};
            const errorStatus = e?.response?.status;
            const errorMessage = errorData?.message || 'Falha ao emitir receita.';

            if (!errorData.errors || errorData.errors === undefined) {
                setLoadingPrescription(false);

                store.addNotification({
                    title: "Erro!",
                    message: `Existem prescrições incompletas! \nRevise os produtos e emita novamente!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 6000,
                        onScreen: true
                    }
                });
                setTimeout(() => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 200);
            } else {

                setLoadingPrescription(false);
                try {
                    const error = errorData?.errors?.agro_art_id?.error;
                    store.addNotification({
                        title: "Erro!",
                        message: `${error || errorMessage}`,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 4000,
                            onScreen: true
                        }
                    });

                } catch (err) {
                    setLoadingPrescription(false);


                    if (e.response.status === 426) {
                        setShowExitValidation(true);
                        setSendPrescription(false);
                    } else {

                        const erro = e.response.data.errors;
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(err, erro),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 6000,
                                onScreen: true
                            }
                        });



                        if (e.response.status === 403) {
                            if (values.stepTwoParams.assinatura.value === 'D') {
                                // setOpenUpload(true);
                                // setShowModalUpload(true);
                                setExistPassword(false);
                                setShowModalPassword(true);
                            }
                        } else if (e.response.status === 409) {
                            if (values.stepTwoParams.assinatura.value === 'D') {
                                setShowModalUpload(true);
                            }
                        }

                    }
                }
            }

            if (e?.response?.status === 423) {
                props.history.push('/historico');
            }

        }
    }

    const setPassword = (senha) => {
        setSenha(senha);
        emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });
    }

    const closeModalPassword = () => {
        setShowModalPassword(false);
    }

    const modalUploadClose = (e) => {

        if (e === undefined) {
            setShowModalUpload(false);

            store.addNotification({
                title: "Atenção!",
                message: `Para continuar, troque o tipo de assinatura!`,
                type: "warning",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 8000,
                    onScreen: true
                }
            });

            setIsOpenStepTwo(true);

            window.scrollTo({
                top: 500,
                left: 0,
                behavior: 'smooth'
            });
        } else {
            setPassword(e);
            setShowModalUpload(false);
        }
    }

    const openModalUpload = () => {
        setShowModalPassword(false);
        setShowModalUpload(true);
    }

    const getCompendioParams = () => {

        if (window.location.search.slice(1).includes('cultures')) {
            setExistCompendioParams(true);

            // cultures=29;29&pests=722;2048&products=5;13&aplications=6;6&relations=18127;18473

            let c = [];
            let pst = [];
            let prod = [];
            let apli = [];
            let rel = [];
            let state = [];
            let d = [];
            let n = [];
            let a = [];
            let q = [];
            let query = window.location.search.slice(1);
            let partes = query.split('&');

            if (partes.length === 10) {
                let cultureSplit = partes[0].split('=');
                cultureSplit = cultureSplit[1].split(';');
                c = cultureSplit;

                let pestSplit = partes[1].split('=');
                pestSplit = pestSplit[1].split(';');
                pst = pestSplit;

                let prodSplit = partes[2].split('=');
                prodSplit = prodSplit[1].split(';');
                prod = prodSplit;

                let apliSplit = partes[3].split('=');
                apliSplit = apliSplit[1].split(';');
                apli = apliSplit;

                let relSplit = partes[4].split('=');
                relSplit = relSplit[1].split(';');
                rel = relSplit;

                let stateSplit = partes[5].split('=');
                stateSplit = stateSplit[1].split(';');
                state = stateSplit;

                let doseSplit = partes[6].split('=');
                doseSplit = doseSplit[1].split(';');
                d = doseSplit;

                let numSplit = partes[7].split('=');
                numSplit = numSplit[1].split(';');
                n = numSplit;

                let areaSplit = partes[8].split('=');
                areaSplit = areaSplit[1].split(';');
                a = areaSplit;

                let qtdSplit = partes[9].split('=');
                qtdSplit = qtdSplit[1].split(';');
                q = qtdSplit;


                let cParams = [];

                rel.map((r, i) => {
                    cParams = [...cParams, {
                        cultura: c[i],
                        praga: pst[i],
                        produto: prod[i],
                        modoAplicacao: apli[i],
                        relacaoId: rel[i],
                        estado: state[0],
                        dose: d[i],
                        numApli: n[i],
                        area: a[i],
                        quantidade: q[i]
                    }];
                })

                setCompendioParams(cParams);
                setLoadParams(true);


            } else {
                setExistCompendioParams(false);
                setLoadParams(true);
            }
        } else {
            if (window.location.search.slice(1)) {

                setExistCompendioParams(true);
                let query = window.location.search.slice(1);
                let partes = query.split('/');

                // 0 - cultura
                // 1 - praga
                // 2 - produto 
                // 3 - modo de aplicação
                // 4 - id relação

                setCompendioParams([
                    {
                        cultura: partes[0],
                        praga: partes[1],
                        produto: partes[2],
                        modoAplicacao: partes[3],
                        relacaoId: partes[4],
                        estado: '*'
                    }
                ]);
                setLoadParams(true);
            } else {

                setExistCompendioParams(false);
                setLoadParams(true);
            }
        }

    }

    const updateOpenRelations = (relations) => {
    }

    const upRelationsIds = (relations) => {
        let existEmptyValue = false;


        relations.map((id) => {
            if (id === 0) {
                existEmptyValue = true;
            }
        })

        setExistEmptyValues(existEmptyValue);
    }

    const getPlanConfig = () => {
        let user = JSON.parse(localStorage.getItem('@userinfo'));

        if (user && user !== null) {
            setPlanoConfig(user.contrato.agro_plan_config);
        }
    }

    const getGeolocation = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLat(position.coords.latitude);
                setLng(position.coords.longitude);
            }, function (error) {
            })
        } else {
        }
    }

    useEffect(() => {
        validaSaldo();
        saveIp();
        getCompendioParams();
        setSubtitle(<>Dúvidas na emissão da sua receita? <a href='https://www.agroreceita.com.br/como-emitir-seu-receituario-agronomico' target='_blank'> Clique aqui e acesse o tutorial. </a> </>);
        getPlanConfig();
        getGeolocation();
    }, []);

    useEffect(() => {
        setTimeout(() => {
            setIniciaVerificacao(false);
        }, 300);
    }, [iniciaVerificacao]);

    useEffect(() => {
        if (sendPrescription === true) {
            setSendPrescription(false);
            emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });

        }
    }, [stepOneParams, stepTwoParams, stepThreeParams, sendPrescription])

    useEffect(() => {
        validatePrescription({ stepOneParams, dataEmissao, stepTwoParams, existParamsStepTwo, stepTwoError, stepThreeParams, existParamsStepThree, stepThreeError });
    }, [stepOneParams, dataEmissao, stepTwoParams, existParamsStepTwo, stepTwoError, stepThreeParams, existParamsStepThree, stepThreeError, existEmptyValues])

    useEffect(() => {
        if (existPassword === true) {
            emitirReceita({ stepOneParams, stepTwoParams, stepThreeParams });
        }
    }, [existPassword])

    useEffect(() => {

        if (stepTwoParams.length !== 0 || stepTwoParams !== undefined) {
            if (stepTwoParams.erroArt === true && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === false) {
                setMsgError('Verifique a ART/TRT!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === true && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === false) {
                setMsgError('Verifique o CREA/VISTO/CFTA!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === true && stepTwoParams.erroUser === false) {
                setMsgError('Verifique o responsável técnico!');
            } else if (stepTwoParams.erroArt === false && stepTwoParams.erroCrea === false && stepTwoParams.erroResponsavel === false && stepTwoParams.erroUser === true) {
                setMsgError('Verifique o usuário para envio da receita a defesa!');
            } else if (stepTwoParams.erroArt === true || stepTwoParams.erroCrea === true || stepTwoParams.erroResponsavel === true || stepTwoParams.erroUser === true) {
                setMsgError('Verifique as opções do responsável técnico!');
            } else {
                if (stepTwoError === true) {
                    if (!stepTwoParams.art) {
                        setMsgError('Verifique a ART/TRT!');
                    } else {
                        setMsgError('Verifique as opções do responsável técnico!');
                    }
                }
            }
        }


        if (stepThreeParams.length !== 0 || stepThreeParams !== undefined) {
            if (stepThreeError === true) {
                if (stepThreeParams.produtor === '' && stepThreeParams.fazenda !== '' && stepThreeParams.devolucao !== '') {
                    setMsgError('Verifique o produtor!');
                } else if (stepThreeParams.produtor !== '' && stepThreeParams.fazenda === '' && stepThreeParams.devolucao !== '') {
                    setMsgError('Verifique o local de aplicação!');
                } else if (stepThreeParams.produtor !== '' && stepThreeParams.fazenda !== '' && stepThreeParams.devolucao === '') {
                    setMsgError('Verifique o local de devolução!');
                } else if (stepThreeParams.produtor === '' || stepThreeParams.fazenda === '' || stepThreeParams.devolucao === '') {
                    setMsgError('Verifique as informações de onde o produto será aplicado!');

                }
            }
        }


    }, [stepOneParams, stepTwoParams, stepTwoError, stepThreeParams, stepThreeError]);

    // Modal de contratos
    const [totalContratos, setTotalContratos] = useState(0);
    const [cadastrados, setCadastrados] = useState(0);
    const [previewNumeroArt, setPreviewNumeroART] = useState('');
    const [showModalBlocked, setShowModalBlocked] = useState(false);
    const [artForSearch, setArtForSearch] = useState(0);
    const [endDateErrorInfo, setEndDateErrorInfo] = useState('');

    const OnClick = async () => {
        let hasError = false;

        if (!inicialDate) {
            setInicialDateError(true);
            hasError = true;
        }

        if (!endDate) {
            setEndDateError(true);
            hasError = true;
        }

        if (!priceContract.trim()) {
            setPriceContractError(true);
            hasError = true;
        }
        
        const emissaoISO = toISODate(dataEmissao);
        const inicioISO = toISODate(inicialDate);
        const fimISO = toISODate(endDate);

        if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
            setInicialDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
        }

        if (emissaoISO && fimISO && emissaoISO > fimISO) {
            setEndDateError(true);
            hasError = true;
            notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
        }

        if (hasError) return;

        setLoadingCreateContract(true);


        try {
            const payload = {
                agro_art_id: stepTwoParams.art.value,
                data_inicio: inicialDate,
                data_termino: endDate,
                valor_contrato: unformatCurrency(priceContract),
                nome_produtor: stepThreeParams.produtor.label,
                agro_farm_id: stepThreeParams.fazenda.value,
            };

            if (endDateError || !endDate) {
                return;
            }

            const response = await api.post('/contratos', payload);

            store.addNotification({
                title: "Sucesso!",
                message: "Contrato criado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            setShowModalBlocked(false);
            setEndDate('');
            setPriceContract('');
            props.updateAfterContrato();

        } catch (error) {
            if (error.response && error.response.status === 422) {
                const errors = error.response.data.errors;
                let errorMessage = "Erro de validação:";

                if (errors) {
                    // Se errors é um objeto com arrays de mensagens
                    if (typeof errors === 'object' && !Array.isArray(errors)) {
                        const errorMessages = [];
                        Object.keys(errors).forEach(field => {
                            if (Array.isArray(errors[field])) {
                                errorMessages.push(...errors[field]);
                            } else {
                                errorMessages.push(errors[field]);
                            }
                        });
                        errorMessage = errorMessages.join(', ');
                    }
                    // Se errors é um array de mensagens
                    else if (Array.isArray(errors)) {
                        errorMessage = errors.join(', ');
                    }
                    // Se errors é uma string
                    else if (typeof errors === 'string') {
                        errorMessage = errors;
                    }
                }

                store.addNotification({
                    title: "Erro ao salvar contrato!",
                    message: identifyErrorMenssage(error, errorMessage),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 6000,
                        onScreen: true
                    }
                });

                if (errorMessage === "Data de termino deve ser posterior a data atual.") {
                    setEndDateError(true);
                }
            }
        } finally {
            setLoadingCreateContract(false);
        }
    };

    const formatCurrency = (value) => {
        const numeric = value.replace(/\D/g, '');

        const number = parseFloat(numeric) / 100;

        if (isNaN(number)) return '';

        return number.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
        });
    };

    const unformatCurrency = (formattedValue) => {
        if (!formattedValue) return 0;
        return parseFloat(
            formattedValue
                .replace(/[R$\s]/g, '')
                .replace(/\./g, '')
                .replace(',', '.')
        );
    };

    const validaContratoSP = async (artId, produtorId, agro_farm_id) => {
        try {
            setPreviewNumeroART(stepTwoParams.art.label)
            const response = await api.get(`/contratos/${artId}/${produtorId}/${agro_farm_id}`);
            return true;
        } catch (e) {
            if (e.response?.status === 422) {
                setShowModalBlocked(true);
                return false;
            }
            throw e;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get(`/contrato/${artForSearch}`);

                const { quantidade_contratos, contratos_cadastrados } = response.data.data;

                setTotalContratos(quantidade_contratos);
                setCadastrados(contratos_cadastrados);
            } catch (error) {
                console.error("Erro ao buscar dados de contratos:", error);
            }
        };

        if (artForSearch) fetchData(); // <- Garante que só busca se tiver ART válida
    }, [artForSearch]);


    const contratosDisponiveis = totalContratos - cadastrados;
    const percentual = totalContratos > 0 ? (cadastrados / totalContratos) * 100 : 0;

    const data = [
        {
            name: 'Contratos',
            fundo: totalContratos,
            preenchido: cadastrados,
        },
    ];

    //Modal Sicca MG
    const [showModalNotificationMG, setShowModalNotificationMG] = useState(false);
    const [shouldReloadEmissaoLote, setShouldReloadEmissaoLote] = useState(false);

    const getNotificacoesMG = async () => {
        try {
            const response = await api.get('/sicca/notificacao');

            if (response.data.status === false) {
                setShowModalNotificationMG(true);
                return true;
            }
            return false;
        } catch (error) {}
        return false;
    }

    useEffect(() => {
        const reloadEmissaoLote = localStorage.getItem("reloadEmissaoLote") === "true";
        if (reloadEmissaoLote) {
            localStorage.setItem("reloadEmissaoLote", "false");
        }

        (async () => {
            const openedModal = await getNotificacoesMG();
            if (reloadEmissaoLote) {
                if (openedModal) {
                    setShouldReloadEmissaoLote(true);
                } else {
                    window.location.reload();
                }
            }
        })();
    }, []);

    return (
        <>
            <GenericUpper
                align={align}
                title={title}
                subtitle={subtitle}
                help={true}
                text={"Dúvidas na emissão da sua receita?"}
                toSearch={'https://agroreceita.com.br/como-emitir-seu-receituario-agronomico/'}
                textToSearch={'Clique aqui e acesse o tutorial!'}
            ></GenericUpper>

            {saldoReceitas !== '' && getIsBasicOrPrePagoPlan() && (
                <DivSaldoContainer>
                    <DivSaldo isMobile={props.isMobile}>
                        Saldo de Receitas: {saldoReceitas}
                    </DivSaldo>
                </DivSaldoContainer>

            )}

            {loadParams ? (
                <>
                    <PrescriptionStepOne
                        updateQuantidadeRelations={updateQuantidadeRelations}
                        update={(value) => updateParamsOne(value)}
                        updateErrorStepOne={(erro) => setErroStepOne(erro)}
                        updateOpenRelations={(r) => updateOpenRelations(r)}
                        updateRelationIds={(ids) => upRelationsIds(ids)}
                        isCompendio={existCompendioParams}
                        compendioParams={compendioParams}
                        countRelations={(value) => setCountRelations(value)}
                        startValidation={iniciaVerificacao}
                        enviaReceita={() => enviarReceita()}
                        maxRelations={false}
                        showIncompleteRelationAlertOnProceedOnly={true}
                        showIncompleteRelationAlertOnlyOnce={true}
                        recipeDraft={dataItemRecipe}
                    />

                    {/* RA-FRONT-2-1372: A sequencia dos steps foi alterada, o "Local de aplicação" foi trocado com o "Responsável técnico", ou seja, 
                    o stepTwo passou a ser o stepTrhee e o stepThree passou a ser o stepTwo. 
                    Não foi alterado os nomes das variaveis que tenham "stepTwo" para "stepThree" e vice-versa para não extender a tarefa/prazo.  */}

                    {/* ANTES ESSE ERA O THREE AGORA É TWO */}
                    <PrescriptionStepTwo
                        error={stepThreeError}
                        existInformation={existParamsStepThree}
                        // disabled={disabledStepThree}
                        disabled={stepOneParams.estado === undefined || dataEmissao === '' || dataEmissao === undefined ? true : false}
                        estado={stepOneParams.estado}
                        crea={stepTwoParams.crea}
                        params={stepThreeParams}
                        art={stepTwoParams.art}
                        responsavel={stepTwoParams.responsavel}
                        recipeDraft={dataItemRecipe}
                        update={(value) => updateParamsThree(value)}
                        isOpen={isOpenStepThree}
                        updateIsOpen={(isOpen) => updateIsOpenStepThree(isOpen)}
                        updateError={(erro) => setStepThreeError(erro)}
                    />

                    {/* ANTES ESSE ERA O TWO AGORA É THREE*/}
                    <PrescriptionStepThree
                        id='resp'
                        error={stepTwoError}
                        existInformation={existParamsStepTwo}
                        disabled={disabledStepThree}
                        // disabled={stepOneParams.estado === undefined || dataEmissao === '' || dataEmissao === undefined ? true : false}
                        dataEmissao={dataEmissao}
                        estado={stepOneParams.estado}
                        params={stepTwoParams}
                        update={(value) => updateParamsTwo(value)}
                        updateError={(erro) => setStepTwoError(erro)}
                        isOpen={isOpenStepTwo}
                        updateIsOpen={(isOpen) => updateIsOpenStepTwo(isOpen)}
                        producerData={stepThreeParams}
                        recipeDraft={dataItemRecipe}
                        inicialDateReceita={inicialDate}
                    />

                    {/* <PrescriptionStepTwo 
                        id='resp'
                        error={stepTwoError}
                        existInformation={existParamsStepTwo}
                        disabled={stepOneParams.estado === undefined || dataEmissao === '' || dataEmissao === undefined ? true : false}
                        dataEmissao={dataEmissao}
                        estado={stepOneParams.estado}
                        params={stepTwoParams}
                        update={(value) => updateParamsTwo(value)}
                        updateError={(erro) => setStepTwoError(erro)}
                        isOpen={isOpenStepTwo}
                        updateIsOpen={(isOpen) => updateIsOpenStepTwo(isOpen)}
                        //updateTourDisabled={(e)=>{props.config.updateTourDisabled02(e) ; updateIsOpenStepTwo(e) ; resetStepThree()}}
                    />
        
                    <PrescriptionStepThree 
                        error={stepThreeError}
                        existInformation={existParamsStepThree}
                        disabled={disabledStepThree}
                        estado={stepOneParams.estado}
                        params={stepThreeParams}
                        art={stepTwoParams.art}
                        crea={stepTwoParams.crea}
                        responsavel={stepTwoParams.responsavel}
                        update={(value) => updateParamsThree(value)}
                        isOpen={isOpenStepThree}
                        updateIsOpen={(isOpen) => updateIsOpenStepThree(isOpen)}
                        updateError={(erro) => setStepThreeError(erro)}
                    /> */}

                    {/* {stepOneParams.estado !== undefined && stepOneParams.estado.value !== "MG" && !isTotvs() &&
                        <PrescriptionStepFour
                            produtos={produtosSelecionados}
                            update={(nf) => setNFeInfo(nf)}
                            disabled={stepOneParams.estado ? stepOneParams.estado.value === 'GO' ? produtosSelecionados.length > 0 ? false : true : false : true}
                            estado={stepOneParams.estado ? stepOneParams.estado.value : ''}
                            erros={errosNfGo}
                        />
                    } */}

                    {/* <PrescriptionStepFive
                        relations={relationsSelecionadas}
                        produtos={produtosSelecionados}
                        update={(nf) => setSiccaInfo(nf)}
                        disabled={stepOneParams.estado ? siccaInfo.estado === 'MG' ? produtosSelecionados.length > 0 ? false : true : false : true}
                        estado={stepOneParams.estado ? stepOneParams.estado.value : ''}
                    /> */}

                    <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px', marginBottom: '60px' }}>
                        <Button
                            width='184px'
                            height='50px'
                            value='GERAR RECEITA'
                            outline={false}
                            disabled={disabledFinish}
                            onClick={() =>  {isTotvs() && !isOmie() ? setShowModalTotvs(true) : setShowModalYesNo(true)}}
                            loading={loadingPrescription}
                            tooltip={true}
                            tooltipMsg={msgError}
                            imagePlus={true}
                        />
                    </div>

                    {showModalYesNo && (
                        <ModalYesNo
                            show={showModalYesNo}
                            onHide={() => setShowModalYesNo(false)}
                            resposta=''
                            update={(e) => updateYesNo(e)}
                            title='Atenção!'
                            text='Tem certeza que deseja finalizar? A responsabilidade pelas informações na receita agronômica é do responsável técnico. Depois de finalizada ela não poderá ser alterada!'
                        ></ModalYesNo>
                    )}

                    {showModalPassword && (
                        <ModalPassword
                            text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                            show={showModalPassword}
                            update={(e) => updatePassword(e)}
                            onHide={() => closeModalPassword()}
                            openUpload={openUpload}
                            onHideToUpload={() => openModalUpload()}
                        />
                    )}

                    {showModalUpload && (
                        <ModalUpload
                            show={showModalUpload}
                            onHide={modalUploadClose}
                            cpf={stepTwoParams.responsavel.cpf}
                            updatePassword={(e) => setPassword(e)}
                        />
                    )}
                </>
            ) : (null)}

            <ModalAlert
                show={!isApto}
                size='lg'
                onHide={() => goHome()}
            >

                {planoConfig.agro_plan_id == 3 ? (
                    <>
                        <h4 style={{
                            width: '100%',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            Seu limite de receitas mensal esgotou!
                        </h4>

                        <p style={{
                            width: '100%',
                            textAlign: 'center'
                        }}>
                            {planoConfig.is_pre_pago ? (
                                'Compre mais receitas ou atualize seu plano para continuar emitindo!'
                            ) : (
                                <>
                                    Seu saldo de <b>{planoConfig.prescriptions_limit}</b> receitas será renovado no dia <b>{formatDate(planoConfig.date_next_renewal)}</b>. Você pode aumentar seu limite de receitas mensal ou fazer um upgrade do seu plano para continuar emitindo!
                                </>
                            )}
                        </p>

                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                            <Button
                                width='170px'
                                height='40px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlans()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />

                            <Button
                                width='170px'
                                height='40px'
                                value='AUMENTAR LIMITE'
                                outline={false}
                                disabled={false}
                                onClick={() => goToLimit()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <h4 style={{
                            width: '100%',
                            marginTop: '10px',
                            textAlign: 'center'
                        }}>
                            Seu saldo para emitir receitas acabou!
                        </h4>

                        {planoConfig.is_pre_pago ? (
                            <p style={{
                                width: '100%',
                                textAlign: 'center'
                            }}>
                                Compre mais receitas ou atualize seu plano para continuar emitindo!'
                            </p>
                        ) : (
                            <>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Precisando de mais receitas? Temos uma surpresa para te contar!
                                </p>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Assinando o AgroReceita nos próximos 14 dias você garante 10% off nas primeiras doze mensalidades.
                                </p>

                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Utilize o cupom <b>+RECEITAS</b> e aproveite todas as funcionalidades do AgroReceita.
                                </p>
                                <p style={{
                                    width: '100%',
                                    textAlign: 'center'
                                }}>
                                    Conheça o plano que mais se encaixa na sua necessidade.
                                </p>
                            </>
                        )}

                        <div className="button-finish" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: '10px' }}>
                            <Button
                                width='170px'
                                height='40px'
                                value='VER PLANOS'
                                outline={false}
                                disabled={false}
                                onClick={() => goToPlans()}
                                loading={false}
                                tooltip={true}
                                tooltipMsg={''}
                            />

                            {planoConfig.is_pre_pago ? (
                                <Button
                                    width='170px'
                                    height='40px'
                                    value='COMPRAR RECEITAS'
                                    outline={false}
                                    disabled={false}
                                    onClick={() => goToReceitas()}
                                    loading={false}
                                    tooltip={true}
                                    tooltipMsg={''}
                                />
                            ) : (null)}
                        </div>
                    </>
                )}
            </ModalAlert>

            {showExitValidation && (
                <ModalYesNo
                    show={showExitValidation}
                    btnNo={true}
                    onHide={() => setShowExitValidation(false)}
                    resposta=''
                    update={(e) => updateYesNoDateValidate(e)}
                    title='Atenção!'
                    text='Já foram emitidas receitas para essa ART com data posterior a data de emissão informada! Deseja emitir a receita mesmo assim? O controle do número de ART/TRT pode ser comprometido!'
                ></ModalYesNo>
            )}
            <ModalGeneric
                show={showModalBlocked}
                onHide={() => setShowModalBlocked(false)}
                marginBottom='0'
            >

                <ContainerModal>
                    <H5>Criar novo Contrato</H5>

                    <BodyM color='#303848'>
                        O Produtor selecionado não possui Contrato ativo na ART/TRT selecionada. Preencha os campos abaixo para criar um Contrato:
                    </BodyM>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginTop: '1.5rem', marginBottom: '0.25rem' }}>

                        <InputV3
                            id="datetime"
                            type="date"
                            label="Selecione Data inicial do Contrato"
                            floatingLabelWithAsterisk="Data inicial do Contrato"
                            value={inicialDate}
                            onChange={(e) => {
                                const value = e.target.value;
                                setInicialDate(value);

                                if (!value) {
                                    setInicialDateError(true);
                                    return;
                                }

                                const emissaoISO = toISODate(dataEmissao);
                                const inicioISO = toISODate(value);

                                if (emissaoISO && inicioISO && emissaoISO < inicioISO) {
                                    setInicialDateError(true);
                                    notifyContratoDateError("A data de emissão da receita deve ser maior ou igual à data de início do contrato.");
                                } else {
                                    setInicialDateError(false);
                                }

                                if (endDate) {
                                    const fimISO = toISODate(endDate);
                                    if (emissaoISO && fimISO && emissaoISO > fimISO) {
                                        setEndDateError(true);
                                        setEndDateErrorInfo("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                        notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                    }
                                }
                            }}
                            disabled={false}
                            hasError={inicialDateError}
                        />

                         <InputV3
                            id="datetime"
                            type="date"
                            label="Selecione Data final do Contrato (prevista)"
                            floatingLabelWithAsterisk="Data final do Contrato"
                            value={endDate}
                            onChange={(e) => {
                                const value = e.target.value;
                                setEndDate(value);

                                const hoje = new Date();
                                const final = new Date(value);
                                const inicio = new Date(inicialDate);
                                const emissaoISO = toISODate(dataEmissao);
                                const fimISO = toISODate(value);

                                if (!value) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('Preencha a data final.');
                                } else if (final < inicio) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('A data final não pode ser menor que a data inicial.');
                                    notifyContratoDateError('A data final do contrato não pode ser menor que a data inicial do contrato.');
                                } else if (inicialDate && final < inicio) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo('A data final não pode ser menor que a data inicial.');
                                    notifyContratoDateError('A data final do contrato não pode ser menor que a data inicial do contrato.');
                                } else if (emissaoISO && fimISO && emissaoISO > fimISO) {
                                    setEndDateError(true);
                                    setEndDateErrorInfo("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                    notifyContratoDateError("A data de emissão da receita deve ser menor ou igual à data final do contrato.");
                                } else {
                                    setEndDateError(false);
                                    setEndDateErrorInfo('');
                                }
                            }}
                            hasError={endDateError}
                        />

                        <InputV3
                            type="text"
                            floatingLabelWithAsterisk="Valor estimado do Contrato (R$)"
                            value={priceContract}
                            onChange={(e) => {
                                const formatted = formatCurrency(e.target.value);
                                setPriceContract(formatted);
                                if (formatted.trim()) setPriceContractError(false);
                            }}
                            onKeyDown={(e) => {
                                const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                const isNumber = /^[0-9]$/.test(e.key);

                                if (!isNumber && !allowedKeys.includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            hasError={priceContractError}
                        />

                    </div>

                    <div>
                        {totalContratos > 0 && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                                <div style={{ maxWidth: '160px', width: '100%' }}>
                                    <BarChart
                                        width={160}
                                        height={6}
                                        data={data}
                                        layout="vertical"
                                        barSize={4}
                                        style={{ borderRadius: '20px' }}
                                    >
                                        <XAxis type="number" hide domain={[0, totalContratos]} />
                                        <YAxis type="category" dataKey="name" hide />
                                        <Bar dataKey="preenchido" stackId="a" radius={[20, 20, 20, 20]}>
                                            <Cell fill={theme.colors.green.Verde_AgroReceita} />
                                        </Bar>

                                        <Bar dataKey="fundo" stackId="a" radius={[20, 20, 20, 20]}>
                                            <Cell fill={theme.colors.disabled.Fundo_Desabilitado} />
                                        </Bar>

                                    </BarChart>
                                </div>

                                <Auxiliar fontWeight="700" style={{ marginTop: '1rem' }}>
                                    {contratosDisponiveis} Contratos disponíveis de {totalContratos}
                                </Auxiliar>
                            </div>
                        )}

                        <Auxiliar fontWeight='400' color="#586377">ART: {previewNumeroArt}</Auxiliar>
                    </div>

                    <ButtonPlans>
                        <ButtonV2
                            width='100%'
                            height='60px'
                            value='Criar Novo Contrato'
                            outline={false}
                            disabled={loadingCreateContract}
                            onClick={OnClick}
                            loading={loadingCreateContract}
                        />
                    </ButtonPlans>
                </ContainerModal>
            </ModalGeneric>

            <ModalGeneric
                show={showUpgradeCreditsModal}
                onHide={() => setShowUpgradeCreditsModal(false)}
                marginBottom='0'
            >
                <ContainerModal>
                    <img
                        src={UndrawAlert}
                        alt="Alerta de créditos"
                        style={{ width: '11rem', display: 'block', margin: '0 auto 0.75rem auto' }}
                    />
                    <H5>{Number(saldoReceitas) === 0 ? 'Seus créditos acabaram' : 'Seus créditos estão acabando…'}</H5>

                    <BodyG color={theme.colors.darkGray2}>
                        Faça um upgrade agora mesmo e tenha créditos ilimitados. Utilize o cupom <b>UP20</b> para obter 20% de desconto nos planos Light e Pro.
                    </BodyG>

                    <ButtonPlans>
                        <ButtonV2
                            width='170px'
                            height='40px'
                            value='VER PLANOS'
                            outline={false}
                            disabled={false}
                            onClick={() => goToPlansWithCoupon()}
                            loading={false}
                            tooltip={false}
                            tooltipMsg=''
                        />
                    </ButtonPlans>
                </ContainerModal>
            </ModalGeneric>

            {showExitValidation && (
                <ModalYesNo
                    show={showExitValidation}
                    btnNo={true}
                    onHide={() => (setShowExitValidation(false), setLoadingPrescription(false))}
                    resposta=""
                    update={(e) => updateYesNoDateValidate(e)}
                    title="Atenção!"
                    state={stepOneParams.estado.value}
                    type='nfe'
                    text={`Os dados da Nota Fiscal não foram informados neste momento, pois dependem do número da receita. Você poderá completar essas informações em até 7 dias, conforme exigência do ${orgaoHomologacaoNfAposReceita(stepOneParams.estado.value)}.`}
                />
            )}

            <ModalAlertTotvs 
                show={showModalTotvs}
                marginBottom="0"
                onHide={() => setShowModalTotvs(false)}
            />

            <ModalAlert
                width="500px"
                show={showModalNotificationMG}
                onHide={() => {
                    setShowModalNotificationMG(false);
                    if (shouldReloadEmissaoLote) {
                        window.location.reload();
                    }
                }}
                >
                <h4 style={{ textAlign: "center" }}>Aviso:</h4>
        
                <p
                    style={{
                    textAlign: "center",
                    marginTop: "20px",
                    }}
                >
                    A partir de agora, o AgroReceita permitirá a geração do relatório de comercialização para o SICCA MG com as informações da NF, conforme a <a href="https://www.nfe.fazenda.gov.br/portal/exibirArquivo.aspx?conteudo=7fsG1qp0vrU= ">Nota Técnica 2024.003</a>.
                    <br />
                    Os receituários agronômicos devem ser emitidos antes da nota fiscal e, somente após isso, você poderá preencher os dados da NF no sistema.
                </p>
        
                <div
                    className="button-finish"
                    style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: "40px",
                    }}
                >
                    <Button
                    width="296px"
                    height="50px"
                    value="ENTENDI"
                    outline={false}
                    disabled={false}
                    onClick={() => {
                        setShowModalNotificationMG(false);
                        if (shouldReloadEmissaoLote) {
                            window.location.reload();
                        }
                    }}
                    loading={false}
                    />
                </div>
            </ModalAlert>
        </>
    );
};

export default withRouter(AddReceitasLote);
